<template>
  <div ref="content" class="text">{{content}}</div>
</template>

<script>
export default {
  props: {
    content: String,
  },
  mounted() {
    // this.$emit('getHeight',this.$refs.content)
    // document.onload(() => {
    //   if (this.$refs.content.offsetHeight - 22 > 65) {
    //     this.$emit("showMore", true);
    //   }
    // })
    this.$nextTick(() => {
      if (this.$refs.content.offsetHeight - 22 > 65) {
        this.$emit('showMore', true);
      }
    })
  },
};
</script>

<style lang="scss" scoped>
.text {
  font-size: 14px;
  font-weight: 400;
  color: rgba(141, 146, 153, 1);
  line-height: 22px;
}
</style>